import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApiService } from "../../api";
import styles from "./CommitmentTrackingContent.module.css";
import { ThemeList, CommitmentList, CommitmentRightPanel } from "./components";
import { setRightPanelWidth } from "./slice/commitmentTrackingSlice";

const CommitmentTrackingContent = () => {
	const cancelTokenSourceRef = useRef();
	const dispatch = useDispatch();
	const leftPanelWidth = useSelector(({ commitmentTracking }) => commitmentTracking.leftPanelWidth);
	const rightPanelWidth = useSelector(({ commitmentTracking }) => commitmentTracking.rightPanelWidth);
	const openDrawer = useSelector(({ commitmentTracking }) => commitmentTracking.openDrawer);
	const selectedTheme = useSelector(({ commitmentTracking }) => commitmentTracking.selectedTheme);
	const selectedCommitment = useSelector(({ commitmentTracking }) => commitmentTracking.selectedCommitment);
	const showRightPanel = selectedTheme || selectedCommitment;

	useEffect(() => {
		cancelTokenSourceRef.current = ApiService.getCancelTokenSource();
		return () => {
			ApiService.cancelTokens(cancelTokenSourceRef.current);
		};
	}, []);

	const handleResizeRightPanel = (newWidth) => {
		dispatch(setRightPanelWidth(newWidth));
	};

	const calculateCenterWidth = () => {
		const leftWidth = openDrawer ? `${leftPanelWidth}vw` : "64px";
		if (showRightPanel) {
			return `calc(${100 - rightPanelWidth}vw - ${leftWidth})`;
		}
		return `calc(100vw - ${leftWidth} - 96px)`;
	};

	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<div
					className={styles.leftPanel}
					style={{
						width: openDrawer ? `${leftPanelWidth}vw` : "auto",
						transition: "width 0.3s ease-in-out",
					}}
				>
					<ThemeList open={openDrawer} />
				</div>
				<div
					className={styles.centerPanel}
					style={{
						width: calculateCenterWidth(),
						transition: "width 0.3s ease-in-out",
					}}
				>
					<CommitmentList />
				</div>
				<div
					className={styles.rightPanel}
					style={{
						width: showRightPanel ? `${rightPanelWidth}vw` : "0",
						minWidth: showRightPanel ? "300px" : "0",
						display: showRightPanel ? "flex" : "none",
						transition: "width 0.3s ease-in-out",
					}}
				>
					<CommitmentRightPanel onResizePanel={handleResizeRightPanel} />
				</div>
			</div>
		</div>
	);
};

export default CommitmentTrackingContent;
